import React from "react"
import Seo from "../components/seo"

const Redirect = () => {
  return <Seo  />
}

export default Redirect
